import React from 'react';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type NotFoundErrorPageType from '@jira/platform__not-found-error-page/src/NotFoundErrorPage.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';

export const LazyExplicitFieldsProjectListPromise: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof NotFoundErrorPageType>(
		() =>
			import(
				/* webpackChunkName: "async-error-pages-not-found", jiraSpaEntry: "async-error-pages-not-found" */ '@jira/spa-apps__error-pages-not-found/src/ErrorPagesNotFoundPage.tsx'
			),
	);

// This route is in the middle of a feature flag cleanup. I will remove the whole file in the next PR.
export const LazyExplicitFieldsProjectListPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyExplicitFieldsProjectListPromise}
		pageId="errors-404"
		shouldShowSpinner={false}
	/>
);
